<div fxLayout="row wrap">
    <mat-toolbar style="width: 100%;" color="primary">
        <span>{{ isCopySpec ? 'Copy ' : 'Edit '}} Print Folder</span>
        <span class="example-spacer"></span>
        <div fxFlex="10" fxLayoutAlign="end" >
            <button mat-icon-button (click)="close()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </mat-toolbar>
</div>

<br>

<div *hasPermission="['EDIT_SPEC']" fxLayout="row wrap" fxLayoutAlign="center" style="margin-top: 10px;">
    <div fxFlex="96" fxFlex.xs="100">
        <app-print-spec-header [headerForm]="folderService.headerForm" [categoryId]="categoryId"></app-print-spec-header>
    </div>
</div>

<div fxLayout="row wrap" fxLayoutAlign="center" style="margin-top: 10px;">
    <div fxFlex="96" fxFlex.xs="100">
        <mat-dialog-content>
            <app-folder [folderLists]="folderLists" [photopackLists]="photopackLists" (submitForm)="submitForm()"></app-folder>
        </mat-dialog-content>
    </div>
</div>